import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => ({
    illustrationShareRootBox: {
      margin: theme.spacing(2),
    },
    textAlignCenter: {
      textAlign: 'center',
    },
    illustrationShareInfoBox: {
      margin: theme.spacing(2, 0, 1),
      display: 'flex',
      justifyContent: 'space-between',
      '& .MuiTypography-root': {
        lineHeight: 2.5,
      },
    },
    subTitle: {
      paddingTop: '10px',
      marginLeft: '20px',
    },
    itemContainer: {
      width: '100%',
      margin: 'auto',
      '& .MuiFilledInput-root': {
        backgroundColor: 'unset',
      },
      '& .MuiInputLabel-root': {
        color: theme.palette.primary.dark,
        fontWeight: '600 !important',
      },
    },
    dialogContent: {
      paddingTop: theme.spacing(3),
    },
  }),
  {index: 1},
);

export default useStyles;
